var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-drop-down",
    {
      attrs: { "is-open": _vm.dropDownOpen, align: "right" },
      on: { close: _vm.toggleDropDown },
    },
    [
      _c("div", { attrs: { slot: "toggler" }, slot: "toggler" }, [
        _c(
          "button",
          {
            staticClass: "action with-icon",
            on: { click: _vm.toggleDropDown },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("archive")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.rfpId && _vm.side === "BUYER" ? "Reports and " : ""
                ) + "Exports"
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        {
          class: _vm.$style.dropdownContainer,
          attrs: { slot: "dropdown" },
          on: { click: _vm.toggleDropDown },
          slot: "dropdown",
        },
        [
          _vm.rfpId && _vm.side === "BUYER"
            ? [
                _c("div", { class: _vm.$style.title }, [_vm._v(" Reports ")]),
                _c(
                  "button",
                  {
                    staticClass: "rbButtonMenuItem",
                    on: {
                      click: function ($event) {
                        return _vm.negotiatedSavings()
                      },
                    },
                  },
                  [_vm._v(" Negotiated Savings ")]
                ),
                _c("div", { class: _vm.$style.title }, [_vm._v(" Exports ")]),
              ]
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportBidManagerToExcel()
                },
              },
            },
            [_vm._v(" Bid Manager ")]
          ),
          _vm.isBidManagerAgencyExportAllowed
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.exportToFile(
                        "HOTEL_RFP:BID_MANAGER_AGENCY_EXPORT:CSV"
                      )
                    },
                  },
                },
                [_vm._v(" Bid Manager Plus (csv) ")]
              )
            : _vm._e(),
          _vm.rfpId
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.exportTravelDestinationsToExcel()
                    },
                  },
                },
                [_vm._v(" Travel Destinations ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportGbtaToExcel()
                },
              },
            },
            [_vm._v(" GBTA (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: { click: _vm.exportGbtaToCsv },
            },
            [_vm._v(" GBTA (csv) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: { click: _vm.exportGbtaByStatusToCsv },
            },
            [_vm._v(" GBTA: with Status (csv) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: { click: _vm.exportGbtaLastOfferByStatusToCsv },
            },
            [_vm._v(" GBTA: Last Offer with Status (csv) ")]
          ),
          _vm.canExportNegotiationRequests
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: { click: _vm.exportGbtaNegotiationRequestsToCsv },
                },
                [_vm._v(" GBTA: Negotiation Requests (csv) ")]
              )
            : _vm._e(),
          _vm.canExportNegotiationResponseAnalysis
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: { click: _vm.exportNegotiationResponseAnalysis },
                },
                [_vm._v(" Negotiation Response Analysis (csv) ")]
              )
            : _vm._e(),
          _vm.selectionContainsFinalAgreements
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.exportFinalAgreementsToExcel()
                    },
                  },
                },
                [_vm._v(" Final Agreements (xlsx) ")]
              )
            : _vm._e(),
          _vm.selectionContainsFinalAgreements
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.exportFinalAgreementsWithStatusToExcel()
                    },
                  },
                },
                [_vm._v(" Final Agreements with Status (xlsx) ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_PRDS_NEW:EXCEL")
                },
              },
            },
            [_vm._v(" PRDS (xlsx) ")]
          ),
          _vm.isPrdsAmexExportAllowed
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.prdsAmexExport()
                    },
                  },
                },
                [_vm._v(" PRDS AMEX (xlsx) ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_CONCUR-SABRE:EXCEL")
                },
              },
            },
            [_vm._v(" Concur - SABRE (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_CONCUR-APOLLO:EXCEL")
                },
              },
            },
            [_vm._v(" Concur - APOLLO (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel(
                    "HOTEL_RFP:GBTA_CONCUR-AMADEUS:EXCEL"
                  )
                },
              },
            },
            [_vm._v(" Concur - AMADEUS (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel(
                    "HOTEL_RFP:GBTA_CONCUR-WORLDSPAN:EXCEL"
                  )
                },
              },
            },
            [_vm._v(" Concur - WORLDSPAN (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToFile("HOTEL_RFP:GBTA_HARP:CSV")
                },
              },
            },
            [_vm._v(" Harp (csv) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToFile("HOTEL_RFP:GBTA_HARP_WITH_STATUS:CSV")
                },
              },
            },
            [_vm._v(" Harp with Bid Status (csv) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_TRVL:EXCEL")
                },
              },
            },
            [_vm._v(" Travel Inc (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_TRVL_2023:EXCEL")
                },
              },
            },
            [_vm._v(" Travel Inc 2023 (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel(
                    "HOTEL_RFP:GBTA_CONCUR-WORLDSPAN_TRVLINC:EXCEL"
                  )
                },
              },
            },
            [_vm._v(" Travel Inc - Concur 2023 (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_SABRE:EXCEL")
                },
              },
            },
            [_vm._v(" Sabre GetThere (xlsx) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_SABRE:SABRE:EXCEL")
                },
              },
            },
            [_vm._v(" Sabre GetThere (Sabre GDS codes) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_SABRE:APOLLO:EXCEL")
                },
              },
            },
            [_vm._v(" Sabre GetThere (Apollo GDS codes) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel(
                    "HOTEL_RFP:GBTA_SABRE:WORLDSPAN:EXCEL"
                  )
                },
              },
            },
            [_vm._v(" Sabre GetThere (Worldspan GDS codes) ")]
          ),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:GBTA_SABRE:AMADEUS:EXCEL")
                },
              },
            },
            [_vm._v(" Sabre GetThere (Amadeus GDS codes) ")]
          ),
          _vm.canExportNegotiationRequests
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.exportNegotiationRequestsWithHistory()
                    },
                  },
                },
                [_vm._v(" Export Negotiation Requests with History ")]
              )
            : _vm._e(),
          _vm.canExportNegotiationRequests
            ? _c(
                "button",
                {
                  staticClass: "rbButtonMenuItem",
                  on: {
                    click: function ($event) {
                      return _vm.exportNegotiationRequestsOnly()
                    },
                  },
                },
                [_vm._v(" Export Negotiation Requests Only ")]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButtonMenuItem",
              on: {
                click: function ($event) {
                  return _vm.exportToExcel("HOTEL_RFP:CLIENT_RATE_REPORT:EXCEL")
                },
              },
            },
            [_vm._v(" Client Rate Report ")]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }